import { render, staticRenderFns } from "./CustomersDistribution.vue?vue&type=template&id=44da72d8"
import script from "./CustomersDistribution.vue?vue&type=script&lang=js"
export * from "./CustomersDistribution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports